import { render, staticRenderFns } from "./LoaderCircle.vue?vue&type=template&id=2e2c1ec8&scoped=true&"
import script from "./LoaderCircle.vue?vue&type=script&lang=js&"
export * from "./LoaderCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2c1ec8",
  null
  
)

export default component.exports